// @flow
/* Auto-generated - start - do not modify in this block */
/* eslint-disable import/prefer-default-export */
export { default as castDataToAuthData } from './castDataToAuthData';
/* Auto-generated - end */



// WEBPACK FOOTER //
// ./src/modules/auth/utils/index.js